import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { RegistrationUserProfile } from '@jct/api';
import { L10nService } from '@jct/localization';
import { AppLayoutService } from '@jct/ui';
import { PageTitleService } from '@jct/core';

const AUTH_SHELL_ROUTES = [
  '/start',
  '/reset-process',
  '/sent-new-password',
  '/calculator',
  '/contact',
];
const LOGIN_ACTION_ROUTES = ['/calculator', '/contact'];

@Component({
  templateUrl: './public-app.component.html',
})
export class PublicAppComponent implements OnInit, OnDestroy {
  private routerSub: Subscription;

  useAuthShell = false;
  showLoginAction = false;
  showCalculatorAction = true;

  constructor(
    public appLayout: AppLayoutService,
    public pageTitle: PageTitleService,
    public l10n: L10nService,
    public userProfile: RegistrationUserProfile,
    private router: Router,
  ) {
    this.updateShell(this.router.url);
  }

  ngOnInit() {
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateShell(event.urlAfterRedirects || event.url);
      });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  private updateShell(url: string) {
    const path = (url || '').split('?')[0];
    const matchesPath = (prefix: string) => path === prefix || path.startsWith(`${prefix}/`);

    this.useAuthShell = AUTH_SHELL_ROUTES.some(matchesPath);
    this.showLoginAction = LOGIN_ACTION_ROUTES.some(matchesPath);
    this.showCalculatorAction = !matchesPath('/calculator');
  }
}
